import React from 'react';
import { FadeIn, Button, Section, FloralSeparator } from '../ui/Shared';
export const UrgencyBar = () => <div className="sticky top-0 z-50 bg-pink-primary text-white py-2 px-4 text-center text-sm md:text-base font-body shadow-md" data-id="element-1">
    <p className="animate-pulse-soft" data-id="element-2">
      ✨ OFERTA POR TIEMPO LIMITADO — Solo por hoy: <strong data-id="element-3">$19.999 ARS</strong>{' '}
      (antes $49.900){' '}
      <span className="hidden md:inline" data-id="element-4">
        {' '}
        | Entrega inmediata a tu correo | 7 días de garantía total
      </span>{' '}
      ✨
    </p>
  </div>;
export const HeroSection = () => <section className="relative pt-10 pb-10 px-4 overflow-hidden bg-gradient-to-b from-pink-light via-white to-celeste-light" data-id="element-5">
    {/* Decorative background elements */}
    <div className="absolute top-10 left-10 text-pink-primary/20 text-6xl blur-[2px] rotate-12" data-id="element-6">
      🌸
    </div>
    <div className="absolute bottom-20 right-10 text-celeste-primary/30 text-6xl blur-[1px] -rotate-12" data-id="element-7">
      ✨
    </div>

    <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-8">
      <FadeIn data-id="element-9">
        <p className="font-heading italic text-xl md:text-2xl text-celeste-deep mb-3" data-id="element-10">
          — Para la mamá que sonríe hacia afuera pero por dentro está agotada —
        </p>
        <h1 className="text-5xl md:text-7xl font-bold text-pink-deep mb-4 leading-tight text-balance" data-id="element-11">
          Hoy empieza tu regreso a vos misma.
        </h1>

        {/* Product image */}
        <div className="max-w-sm md:max-w-md mx-auto mb-4" data-id="element-12">
          <img src="https://cdn.magicpatterns.com/uploads/uRf3NDZHdwbat5tQQ2nVPJ/WhatsApp_Image_2026-03-15_at_17.08.59_(2).jpg" alt="Renacer Después del Parto — Tomo 1 y Tomo 2" className="rounded-2xl shadow-xl w-full object-cover" data-id="element-13" />
        </div>

        <h2 className="text-2xl md:text-3xl font-heading italic text-brown-text mb-3" data-id="element-14">
          No estás rota. No estás fallando. Solo necesitabas el camino correcto.
        </h2>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-15">
        <p className="text-lg md:text-xl mb-2 font-medium" data-id="element-16"></p>
        <p className="text-lg md:text-xl italic text-brown-text/80 mb-4 max-w-3xl mx-auto" data-id="element-17">
          Renacer Después del Parto es el método paso a paso que te acompaña a
          recuperar tu estabilidad emocional, tu descanso y tu paz interior en 4
          semanas.
        </p>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-18">
        <div className="inline-block bg-white/60 backdrop-blur-sm px-6 py-3 rounded-full border border-pink-border mb-4" data-id="element-19">
          <p className="text-sm md:text-base font-medium text-pink-deep" data-id="element-20">
            🌸 2 Tomos Completos + 4 Bonos Exclusivos · 100% Digital · Acceso
            Inmediato
          </p>
        </div>

        <div className="flex flex-col items-center" data-id="element-21">
          <Button href="#comprar" className="w-full sm:w-auto text-xl py-5 px-10 mb-2" data-id="element-22">
            SÍ, QUIERO EMPEZAR MI RENACER
          </Button>
          <p className="text-sm text-brown-text/70" data-id="element-23">
            ↓ Acceso inmediato · Entrega a tu correo · Sin esperas ↓
          </p>
        </div>
      </FadeIn>
    </div>
  </section>;
export const PainRecognition = () => <Section className="bg-cream text-center" data-id="element-24">
    <FadeIn data-id="element-25">
      <FloralSeparator data-id="element-26" />
      <h2 className="text-3xl md:text-4xl italic mb-6" data-id="element-27">
        ¿Reconocés alguna de estas sensaciones?
      </h2>

      <div className="max-w-2xl mx-auto space-y-5 text-lg md:text-xl" data-id="element-28">
        <p className="font-bold text-2xl text-pink-deep" data-id="element-29">
          Sonreís cuando alguien te mira.
          <br data-id="element-30" />
          Pero por dentro sentís que algo no está bien.
        </p>

        <div className="space-y-3 text-brown-text/90" data-id="element-31">
          <p data-id="element-32">El cansancio que sentís no es solo físico.</p>
          <p data-id="element-33">Es un peso en el pecho que no se va con dormir.</p>
          <p data-id="element-34">
            Es la voz que aparece de noche preguntando si estás haciéndolo bien.
          </p>
          <p data-id="element-35">
            Es el llanto que viene sin aviso — y la culpa que viene después.
          </p>
        </div>

        <div className="italic text-brown-text/80 py-4" data-id="element-36">
          <p data-id="element-37">Cada mañana te prometés que hoy va a ser diferente.</p>
          <p data-id="element-38">Más paciente. Más presente. Más vos.</p>
          <p data-id="element-39">Y al caer la noche, el agotamiento vuelve.</p>
          <p data-id="element-40">Y con él, el pensamiento que más duele:</p>
        </div>

        <h3 className="text-2xl md:text-3xl font-heading font-bold text-celeste-deep my-5" data-id="element-41">
          "Esto debería ser el momento más feliz de mi vida... ¿Por qué no lo
          siento así?"
        </h3>

        <p className="font-medium" data-id="element-42">
          Si algo de esto resuena en vos, quiero que sepas algo importante:
        </p>

        <div className="bg-pink-light/50 p-5 rounded-2xl border border-pink-border my-5" data-id="element-43">
          <p className="text-2xl font-heading font-bold text-pink-deep" data-id="element-44">
            No estás fallando. No estás rota. No sos menos mamá.
          </p>
        </div>

        <div className="space-y-2" data-id="element-45">
          <p data-id="element-46">Lo que estás viviendo tiene un nombre.</p>
          <p data-id="element-47">Tiene una explicación científica y emocional.</p>
          <p className="font-bold text-pink-deep" data-id="element-48">Y tiene una salida real.</p>
        </div>
      </div>
      <FloralSeparator data-id="element-49" />
    </FadeIn>
  </Section>;